import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../../services/login.service';

@Component({
    selector: 'session-error',
    templateUrl: './session-error.component.html',
    styleUrls: ['./session-error.component.scss']
})
export class SessionErrorComponent implements OnInit, OnDestroy {

    expired!: boolean;

    constructor(private router: Router, private loginService: LoginService) {
    }

    ngOnInit() {
        this.loginService.sessionExpiredSubject.subscribe(
            (value: boolean) => {
                console.log('SessionErrorComponent.ngOnInit.loginService.sessionExpiredSubject', value);
                this.expired = value;
            }
        );
    }

    ngOnDestroy() {
    }

    logout() {
        this.loginService.logout();
        this.router.navigate(['/login']);
    }
}
